import { useGetWorkerContractQuery } from "./api/workContractApiSlice"
import WorkerContractDetail from "./components/WorkerContractDetail"

export default function WorkerWorkContract({
    userGUID
}) {

    const {
        data: workerContract,
        isSuccess,
        isError,
    } = useGetWorkerContractQuery(userGUID)

    if (isSuccess)
        return <WorkerContractDetail contractDetail={workerContract} />
    if (isError)
        return <h4>Nessun contratto attivo</h4>

}